export default __webpack_public_path__ + "3d750f9cbd79e7083412836a3bec18dc.png";